import { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';

// A lazy child that fails to load (a stale chunk after a deploy) must not blank the app: the
// host sits directly under the app-wide error boundary. On failure the flow just closes.
export default class FlowBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(error) {
        Sentry.captureException(error, { tags: { area: 'call-flow' } });
        this.props.onFail();
    }

    render() {
        return this.state.failed ? null : this.props.children;
    }
}

FlowBoundary.propTypes = { onFail: PropTypes.func.isRequired, children: PropTypes.node };
FlowBoundary.defaultProps = { children: null };
